import { Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ITicketAutomationReceivedRuleAllowedAction } from "../../../services/tasySchedMenu.service";
import { ISchedule, IScheduleCheckInRule } from "../model";
import { CheckInButton } from "../MySchedules/CheckInButton/CheckInButton";
import { getScheduleDescriptionLines } from "../MySchedules/scheduleDescription";
import { Calendar } from "../Schedule/Calendar";
import { Type } from "../Schedule/Type";
import { useTranslation } from "react-i18next";

const NewScheduleItem = ({
  data,
  checkInRule,
  basePath = "/schedule",
  allowedAction,
}: {
  data: ISchedule;
  checkInRule: IScheduleCheckInRule;
  basePath?: string;
  allowedAction?: ITicketAutomationReceivedRuleAllowedAction | null;
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onClickHandler = () => {
    navigate(
      `${basePath}/mySchedules/${data.tasySchedulingType.code}/${data.identifier}`,
      { state: { allowedAction } },
    );
  };

  return (
    <Stack
      sx={(t) => ({
        flexDirection: "row",
        gap: t.spacing(2),
        padding: t.spacing(2),
        backgroundColor: t.palette.divider,
        borderRadius: t.shape.borderRadius / 2,
      })}
      onClick={onClickHandler}
    >
      <Calendar date={data.calendarStartDate} />
      <Stack
        sx={(t) => ({
          justifyContent: "space-between",
          flexGrow: 1,
          padding: t.spacing(1),
          flex: 1,
        })}
      >
        <Stack
          sx={(t) => ({
            flexDirection: "row",
            justifyContent: "space-between",
            gap: t.spacing(1),
            alignItems: "center",
          })}
        >
          <Stack sx={{ flex: 1 }}>
            {getScheduleDescriptionLines(data, t).map((line, index) => (
              <Typography key={index} style={{ fontWeight: "500" }}>
                {line}
              </Typography>
            ))}
          </Stack>
          {data.tasySchedulingType.code && (
            <Type type={data.tasySchedulingType.code} />
          )}
        </Stack>
        <Typography style={{ alignSelf: "flex-end", fontSize: 15 }}>
          {data.pacientName}
        </Typography>
        {checkInRule &&
          (basePath !== "/schedule-new" || allowedAction?.checkIn) && (
            <CheckInButton
              calendarStatusCode={data.calendarStatusCode}
              checkInRule={checkInRule}
              encounterIdentifier={data.encounterIdentifier}
              roomName={data.roomName}
              scheduleDate={data.calendarStartDate}
              scheduleTypeCode={data.tasySchedulingType.code!}
              identifier={data.identifier}
            />
          )}
      </Stack>
    </Stack>
  );
};

export default NewScheduleItem;
